<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-top v-if="init">

      <v-flex text-xs-center v-if="errorMessage === 'unknown'">
        <p style="padding-left: 15px">Произошла неизвестная ошибка, обратитесь к администратору</p>
      </v-flex>

      <v-flex text-xs-center v-if="errorMessage === ''">
        <v-layout align-left justify-start row wrap v-if="showAvailableCompanies">
          <v-flex xs12 sm10 md2 lg4>
            <v-select
              v-model="selectedCompany"
              :items="availableCompanies"
              item-text="name"
              item-value="id"
              label="Компания"
              required>
              <template slot='selection' slot-scope='{ item }'>
                {{ item.id }} - {{ item.name }}
              </template>
              <template slot='item' slot-scope='{ item }'>
                {{ item.id }} - {{ item.name }}
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout align-left justify-start row wrap>

          <v-flex xs6 sm3 md2 lg1>
            <v-btn
              @click="syncAppointments"
              color="#4169E1"
              style="color:white"
              title="Синхронизировать записи"
              :disabled="syncDisabled"
            >
              <v-icon>sync</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs6 sm3 md2 lg1>
            <v-btn
              @click.stop="dialogSmsAll = true"
              color="#4169E1"
              style="color:white"
              title="Отправить СМС всем"
              :disabled="smsAllDisabled"
            >
              <v-icon>email</v-icon>
            </v-btn>
            <SendSmsAllConfirmation v-model="dialogSmsAll" @confirmed="sendSmsAll"/>
          </v-flex>

          <v-layout justify-end>
            <v-flex xs12 sm12 md4 lg3>
              <v-text-field
                @click.stop="dialogDate = true"
                v-model="selectedDateFormat"
                label="Выберите дату"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <DatePicker
                v-model="dialogDate"
                :passed-date="selectedDate"
                :max-date="maxDate"
                :min-date="minDate"
                @update-date="updateSelectedDate"/>
            </v-flex>
          </v-layout>
        </v-layout>

        <component
          :my-date="selectedDate"
          :my-company="selectedCompany"
          v-bind:is="syncDataComponent"
          v-on:syncFinish="syncFinish"
          v-on:smsAllFinish="smsAllFinish"
          ref="syncData">
        </component>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SyncDataDesktop from '../components/SyncDataDesktop'
import SyncDataMobile from '../components/SyncDataMobile'
import SendSmsAllConfirmation from '../components/SendSmsAllConfirmation'
import DatePicker from '../components/DatePicker'

export default {
  data: () => ({
    showAvailableCompanies: false,
    availableCompanies: [],
    selectedCompany: '',
    maxDate: '',
    minDate: '',
    dialogDate: false,
    dialogSmsAll: false,
    selectedDate: '',
    errorMessage: '',
    syncDisabled: false,
    smsAllDisabled: false,
    init: false
  }),
  components: {
    SyncDataDesktop,
    SyncDataMobile,
    SendSmsAllConfirmation,
    DatePicker
  },
  created () {
    this.$store.commit('showNavigation')
    this.selectedDate = this.generateTextDate(0)
    this.maxDate = this.generateTextDate(14)
    this.minDate = this.generateTextDate(-1)
    this.initComponent()
  },
  computed: {
    selectedDateFormat: function () {
      const parts = this.selectedDate.split('-')
      return parts[2] + '/' + parts[1] + '/' + parts[0]
    },
    syncDataComponent: function () {
      return window.innerWidth < 961 ? 'SyncDataMobile' : 'SyncDataDesktop'
    }
  },
  methods: {
    syncFinish: function () {
      this.syncDisabled = false
    },
    smsAllFinish: function () {
      this.smsAllDisabled = false
    },
    initComponent: function () {
      this.$http.get('/api/initAppointments/')
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            if (response.data.length > 1) {
              this.showAvailableCompanies = true
            }
            response.data.forEach(item => {
              this.availableCompanies.push({
                id: item.companyId,
                name: item.companyName
              })
              if (item.isDefault === true) {
                this.selectedCompany = item.companyId
              }
            })
            if (this.selectedCompany === '') {
              this.selectedCompany = response.data[0].companyId
            }
          }
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    updateSelectedDate: function (date) {
      this.selectedDate = date
    },
    syncAppointments: function () {
      this.syncDisabled = true
      this.$refs.syncData.syncAppointments()
    },
    sendSmsAll: function () {
      this.smsAllDisabled = true
      this.$refs.syncData.sendSmsAll()
      this.dialogSmsAll = false
    },
    generateTextDate: function (daysDiff) {
      const today = new Date()
      today.setDate(today.getDate() + daysDiff)
      const dd = String(today.getDate()).padStart(2, '0')
      const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
      const yyyy = today.getFullYear()
      return yyyy + '-' + mm + '-' + dd
    }
  }
}
</script>
